/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Arrow from 'src/assets/arrow-left-black.svg';

import {
  CommonDropdown,
  CommonInput,
  FormErrorWrap,
  RegularButton,
  ICommonDropdownOption,
  FullScreenLoading,
  DatePicker,
  OutlinedButton,
} from 'pg-ui-library';
import {
  Container,
  CardContainer,
  HelpForm,
  PageTitle,
  FormInputWrapper,
  NavTextLink,
  ArrowBack,
  HeaderItemLeft,
  ModuleLine,
  SubText,
  ReadOnlyDiv,
} from './createStyles';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { supportDeskOptions, supportDeskSubmodules } from 'src/modules/personal-info';
import { useAddInvoice, useUpdateInvoice } from './mutations/invoice.mutation';
import { AssignmentApiItem, InvoiceFormValues } from 'src/interfaces/invoice';
import InvoiceService from 'src/services/invoice.service';
import { useQuery } from '@tanstack/react-query';
import attachmentBlue from 'src/assets/attachment-blue.svg';
import { useLocalStorage } from 'src/hooks/useLocalStorage';

export const assignmentOptions: ICommonDropdownOption[] = [];

export const toISODate = (date: string | Date): string => {
  if (date instanceof Date) return date.toISOString();
  return new Date(date).toISOString();
};

const EditInvoice: React.FC = () => {
  const { invoiceId } = useParams<{ invoiceId: string }>();
  const [existingAttachments, setExistingAttachments] = useState<any[]>([]);
  const [deletedAttachmentIds, setDeletedAttachmentIds] = useState<string[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState<ICommonDropdownOption[]>(
    supportDeskSubmodules[supportDeskOptions[0].value]
  );
  const [showFun, setShowFun] = useState(true);

  const { isFetching, data, refetch } = useQuery(['invoice-details'], async () => {
    const result = await InvoiceService.getInvoiceEditDetails({ invoiceId: invoiceId });
    return result.data;
  });

  const [contractStartDate, setContractStartDate] = useState<Date | null>(null);
  const [contractEndDate, setContractEndDate] = useState<Date | null>(null);

  const [userRole] = useLocalStorage('userRole', null);

  useEffect(() => {
    if (userRole === 'external_manager') {
      setShowFun(false);
    } else {
      setShowFun(true);
    }
  }, [userRole]);

  useEffect(() => {
    if (data) {
      if (data.attachments) {
        setExistingAttachments(data.attachments);
      }

      setContractEndDate(data.contractEndDate ? new Date(data.contractEndDate) : null);

      setContractStartDate(data.contractStartDate ? new Date(data.contractStartDate) : null);
    }
  }, [data]);

  const handleRemoveExistingFile = (index: number, attachment: any) => {
    setDeletedAttachmentIds(prev => [...prev, attachment.id]);

    setExistingAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const addInvoice = useAddInvoice();
  const updateInvoice = useUpdateInvoice();
  const navigate = useNavigate();

  const validationSchema = yup.object({
    assignmentId: yup.string().max(255).required('Assignment is required'),
    invoiceDate: yup.date().nullable().required('Invoice date is required'),
    periodStart: yup.date().nullable().required('Period Start is required'),
    periodEnd: yup.date().nullable().required('Period End is required'),
    invoiceAmount: yup.string().required('Invoice Amount is required'),
    totalUnits: yup.string().required('Total Units is required'),
    // attachments: yup.array().min(1, 'Attachments is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      workerId: data?.employeeId || '',
      assignmentId: data?.assignmentId || '',
      assignmentName: data?.assignmentName || '',
      clientId: data?.clientId || '',
      clientName: data?.clientName || '',
      companyName: data?.companyName || '',
      supplierName: data?.supplierName || '',
      invoiceNumber: data?.invoiceNumber || '',
      jobTitle: data?.jobTitle || '',
      hireType: data?.hireType || '',
      invoiceDate: data?.invoiceDate ? new Date(`${data.invoiceDate}T00:00:00`) : null,
      periodStart: data?.periodStart ? new Date(`${data.periodStart}T00:00:00`) : null,
      periodEnd: data?.periodEnd ? new Date(`${data.periodEnd}T00:00:00`) : null,
      invoiceAmount: data?.invoiceAmount || '',
      totalUnits: data?.totalUnits || '',
      totalHours: data?.totalHours || '',
      billRate: data?.billRate || '',
      payRate: data?.payRate || '',
      rateMarkup: data?.rateMarkup || '',
      status: data?.status || '',
      attachments: [],
      notes: data?.notes || '',
      currency: data?.currency || '',
    },
    validationSchema,
    onSubmit: async (values: InvoiceFormValues) => {
      const totalAttachments = existingAttachments.length + (values.attachments?.length || 0);

      if (totalAttachments === 0) {
        formik.setFieldError('attachments', 'At least one attachment is required');
        return;
      }
      try {
        const formData = new FormData();
        formData.append('assignmentId', values.assignmentId || '');
        formData.append('assignmentName', values.assignmentName || '');
        formData.append('clientId', values.clientId || '');
        formData.append('clientName', values.clientName || '');
        formData.append('companyName', values.companyName || '');
        formData.append('supplierName', values.supplierName || '');
        formData.append('invoiceDate', values.invoiceDate ? toISODate(values.invoiceDate) : '');
        formData.append('invoiceNumber', values.invoiceNumber || '');
        formData.append('jobTitle', values.jobTitle || '');
        formData.append('hireType', values.hireType || '');
        formData.append('periodStart', values.periodStart ? toISODate(values.periodStart) : '');
        formData.append('periodEnd', values.periodEnd ? toISODate(values.periodEnd) : '');
        formData.append('status', values.status ? values.status : '');
        formData.append('invoiceAmount', values.invoiceAmount || '');
        formData.append('totalUnits', values.totalUnits || '');
        formData.append('totalHours', values.totalHours || '');
        formData.append('billRate', values.billRate || '');
        formData.append('payRate', values.payRate || '');
        formData.append('rateMarkup', values.rateMarkup || '');
        formData.append('notes', values.notes || '');
        formData.append('currency', values.currency || '');
        formData.append('deletedAttachmentIds', JSON.stringify(deletedAttachmentIds));

        uploadedFiles.forEach(file => {
          formData.append('attachments', file);
        });

        // deletedAttachmentIds.forEach(id => {
        //   formData.append('deletedAttachmentIds', id);
        // });

        await updateInvoice.mutateAsync({ id: invoiceId!, invoice: formData });

        navigate(`/invoices/${invoiceId}`);
      } catch (error) {
        console.error('Error during submission of Ticket', error);
      }
    },
  });

  const fileInputRef = React.useRef<any>(null);
  const handleFileUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);

    const updatedFiles = [...uploadedFiles, ...files];

    setUploadedFiles(updatedFiles);

    formik.setFieldValue('attachments', updatedFiles);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);

    setUploadedFiles(updatedFiles);

    formik.setFieldValue('attachments', updatedFiles);
  };
  const handleModuleChange = (event: React.ChangeEvent<HTMLSelectElement> | string) => {
    let selectedModule: string;

    if (typeof event === 'string') {
      selectedModule = event;
    } else {
      selectedModule = event.target.value;
    }

    const newSubCategories = supportDeskSubmodules[selectedModule] || [];

    formik.setFieldValue('module', selectedModule);

    const defaultSubCategory = newSubCategories.length > 0 ? newSubCategories[0].value : '';
    formik.setFieldValue('subCategory', defaultSubCategory);

    setSubCategoryOptions(newSubCategories);
  };

  const isEdit = true;

  const showError = (name: keyof InvoiceFormValues) =>
    !!formik.errors[name] && (formik.touched[name] || formik.submitCount > 0);

  const today = new Date();
  const effectiveMaxDate = contractEndDate && contractEndDate < today ? contractEndDate : today;

  return (
    <Container>
      {isFetching && <FullScreenLoading />}
      <HeaderItemLeft>
        <NavTextLink to={-1 as any}>
          <ArrowBack src={Arrow} />
        </NavTextLink>
        <PageTitle>Edit Invoice</PageTitle>
      </HeaderItemLeft>
      <SubText>{data?.employeeName}</SubText>
      <CardContainer>
        <HelpForm>
          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            {showFun ? (
              ''
            ) : (
              <>
                <CommonInput
                  id="worker"
                  name="workerId"
                  label="Worker *"
                  placeholder="Search by name or email"
                  value={formik.values.workerId}
                  onChange={event => formik.setFieldValue('workerId', event.target.value)}
                  style={{
                    width: '100%',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                    boxSizing: 'border-box',
                  }}
                />
                <FormErrorWrap errorMessage={formik.errors.workerId as string} visible={!!formik.errors.workerId} />
              </>
            )}
          </FormInputWrapper>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            {isEdit ? (
              <FormInputWrapper>
                <label
                  htmlFor="Assignment"
                  style={{
                    display: 'block',
                    marginBottom: '8px',
                    fontSize: '16px',
                    color: '#222247',
                  }}
                >
                  Assignment *
                </label>
                <ReadOnlyDiv role="textbox" aria-readonly="true" title={formik.values?.assignmentName}>
                  {`${formik.values?.assignmentName} (${formik.values?.assignmentId}) - ${formik.values?.clientName}` ||
                    ''}
                </ReadOnlyDiv>
              </FormInputWrapper>
            ) : (
              <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
                <CommonDropdown
                  label="Assignment *"
                  id="assignmentId"
                  name="assignmentId"
                  options={assignmentOptions}
                  value={formik.values.assignmentId}
                  setValue={handleModuleChange}
                  selectStyle={{
                    width: '100%',
                    height: '35px',
                    borderRadius: '7px',
                    border: '1px solid #ccc',
                  }}
                />
                <FormErrorWrap
                  errorMessage={formik.errors.assignmentId as string}
                  visible={!!formik.errors.assignmentId}
                />
              </FormInputWrapper>
            )}

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <DatePicker
                id="invoiceDate"
                name="invoiceDate"
                label="Invoice Date *"
                dateFormat="MM/dd/yyyy"
                maxDate={new Date()}
                selected={formik.values.invoiceDate ?? null}
                onChange={(val: Date | null) => formik.setFieldValue('invoiceDate', val)}
                autoComplete="off"
              />
              <FormErrorWrap errorMessage={formik.errors.invoiceDate as string} visible={!!formik.errors.invoiceDate} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="invoiceNumber"
                name="invoiceNumber"
                label="Invoice Number"
                placeholder="External Reference ID"
                value={formik.values.invoiceNumber}
                onChange={event => formik.setFieldValue('invoiceNumber', event.target.value)}
                autoComplete="off"
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap
                errorMessage={formik.errors.invoiceNumber as string}
                visible={!!formik.errors.invoiceNumber}
              />
            </FormInputWrapper>
          </ModuleLine>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              <DatePicker
                id="periodStart"
                name="periodStart"
                label="Period Start *"
                dateFormat="MM/dd/yyyy"
                selected={formik.values.periodStart ?? null}
                onChange={(val: Date | null) => formik.setFieldValue('periodStart', val)}
                autoComplete="off"
                // disabled={!allowEditDelete}
                minDate={contractStartDate ?? undefined}
                maxDate={effectiveMaxDate}
              />
              <FormErrorWrap errorMessage={formik.errors.periodStart as string} visible={!!formik.errors.periodStart} />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '108%' }}>
              <DatePicker
                id="periodEnd"
                name="periodEnd"
                label="Period End *"
                dateFormat="MM/dd/yyyy"
                selected={formik.values.periodEnd ?? null}
                onChange={(val: Date | null) => formik.setFieldValue('periodEnd', val)}
                autoComplete="off"
                // disabled={!allowEditDelete}
                minDate={formik.values.periodStart ?? contractStartDate ?? undefined}
                maxDate={effectiveMaxDate}
              />
              <FormErrorWrap errorMessage={formik.errors.periodEnd as string} visible={!!formik.errors.periodEnd} />
            </FormInputWrapper>
          </ModuleLine>

          <ModuleLine style={{ display: 'flex', gap: '36px', marginBottom: '-10px' }}>
            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="invoiceAmount"
                name="invoiceAmount"
                label="Invoice Amount *"
                placeholder="Money"
                value={formik.values.invoiceAmount}
                onChange={event => formik.setFieldValue('invoiceAmount', event.target.value)}
                autoComplete="off"
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap
                errorMessage={formik.errors.invoiceAmount as string}
                visible={!!formik.errors.invoiceAmount}
              />
            </FormInputWrapper>

            <FormInputWrapper style={{ flex: '1', maxWidth: '78%' }}>
              <CommonInput
                id="totalUnits"
                name="totalUnits"
                label="Total Units/Hours *"
                placeholder="Number"
                value={formik.values.totalUnits}
                onChange={event => formik.setFieldValue('totalUnits', event.target.value)}
                autoComplete="off"
                style={{
                  width: '100%',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                }}
              />
              <FormErrorWrap errorMessage={formik.errors.totalUnits as string} visible={!!formik.errors.totalUnits} />
            </FormInputWrapper>
          </ModuleLine>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '5px', position: 'relative' }}>
            <label
              htmlFor="fileUpload"
              style={{
                display: 'block',
                marginBottom: '5px',
                fontSize: '16px',
                color: '#222247',
              }}
            >
              Attachments *
            </label>
            <input
              ref={fileInputRef}
              id="fileUpload"
              name="Attachment"
              type="file"
              style={{
                display: 'none',
              }}
              onChange={handleFileChange}
            />
            <div
              style={{
                width: '100%',
                height: '136px',
                border: '1px solid #ccc',
                borderRadius: '7px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                position: 'relative',
                marginBottom: '0px',
                boxSizing: 'border-box',
              }}
              onClick={handleFileUploadClick}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  font: '18px/27px Biotif',
                }}
              >
                <span
                  style={{
                    color: '#4A4BA9',
                    fontWeight: 'bold',
                    marginRight: '5px',
                  }}
                >
                  Add files
                </span>
                <span
                  style={{
                    color: '#222247',
                    opacity: 0.5,
                  }}
                >
                  Or drop files here
                </span>
              </div>
            </div>
            <FormErrorWrap errorMessage={formik.errors.attachments as string} visible={!!formik.errors.attachments} />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '20px' }}>
            <div
              style={{
                width: '55%',
                marginTop: '0px',
                paddingTop: '0px',
                borderRadius: '7px',
              }}
            >
              {uploadedFiles.map((file, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#4A4BA9',
                      textDecoration: 'none',
                      marginRight: '10px',
                      fontSize: '12px',
                    }}
                  >
                    {file?.name}
                  </a>
                  <span
                    onClick={() => handleRemoveFile(index)}
                    style={{
                      color: '#4A4BA9',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>

            {existingAttachments.length > 0 && (
              <div style={{ marginTop: '8px', fontSize: '12px' }}>
                {existingAttachments.map((attachment, index) => (
                  <div
                    key={attachment.attachmentUrl}
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '6px' }}
                  >
                    <a
                      href={attachment.attachmentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginRight: '8px', textDecoration: 'none' }}
                    >
                      {attachment.attachmentName}
                    </a>

                    <span
                      onClick={() => handleRemoveExistingFile(index, attachment)}
                      style={{
                        color: '#4A4BA9',
                        cursor: 'pointer',
                        fontSize: '12px',
                      }}
                    >
                      ✕
                    </span>
                  </div>
                ))}
              </div>
            )}
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '0 0 100%', marginBottom: '-10px' }}>
            <label htmlFor="description" style={{ display: 'block', marginBottom: '5px' }}>
              Notes
            </label>
            <textarea
              id="notes"
              name="notes"
              placeholder="Notes"
              value={formik.values.notes}
              onChange={event => formik.setFieldValue('notes', event.target.value)}
              style={{
                width: '100%',
                height: '136px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                boxSizing: 'border-box',
                padding: '10px',
                resize: 'none',
                fontSize: '14px',
                textAlign: 'left',
                verticalAlign: 'top',
              }}
            />
            <FormErrorWrap
              errorMessage={formik.errors.notes as string}
              visible={!!(formik.touched.notes && formik.errors.notes)}
            />
          </FormInputWrapper>

          <FormInputWrapper
            style={{ flex: '0 0 100%', display: 'flex', justifyContent: 'flex-start', marginBottom: '5px' }}
          >
            <OutlinedButton onClick={() => navigate('/invoices')}>Cancel</OutlinedButton>

            <OutlinedButton
              onClick={() => {
                formik.setFieldValue('status', 'Draft');
                formik.handleSubmit();
              }}
              disabled={!formik.isValid || formik.isSubmitting || addInvoice.isLoading}
            >
              Draft
            </OutlinedButton>

            <RegularButton
              onClick={() => {
                formik.setFieldValue('status', 'Submitted');
                formik.handleSubmit();
              }}
              disabled={!formik.isValid || formik.isSubmitting || addInvoice.isLoading}
            >
              Submit
            </RegularButton>
          </FormInputWrapper>
        </HelpForm>
      </CardContainer>
    </Container>
  );
};

export default EditInvoice;
